export default "__VITE_ASSET__CTSTKAyf__"